import { Chip } from "@mui/material";

const StatusChip = ({ status }: { status: string }) => {
  const colorMap: Record<string, "default" | "info" | "success" | "warning" | "error"> = {
    queued: "default",
    sending: "info",
    sent: "success",
    partial: "warning",
    error: "error",
  };
  return (
    <Chip
      label={status}
      size="small"
      color={colorMap[status] || "default"}
      sx={{ textTransform: "capitalize" }}
    />
  );
};

export default StatusChip;
